export default {"src":"/_next/static/media/Colapse.9723b442.svg","height":20,"width":20};